export default "__VITE_ASSET__CcKEhYtd__"